// extracted by mini-css-extract-plugin
module.exports = {"statsSectionLinks":"style-module__statsSectionLinks___jg6go","selectedStatsSectionLink":"style-module__selectedStatsSectionLink___2Xylp"};